import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.555 11.168A1 1 0 0 0 13 12v8a1 1 0 0 0 1.555.832l6-4a1 1 0 0 0 0-1.664zM15 18.13v-4.263L18.197 16z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.982 5.05h.099l.236.001a54.216 54.216 0 0 1 3.76.183c2.276.193 5.174.592 7.405 1.444l.015.006a3.01 3.01 0 0 1 1.796 2.04v.003C29.606 9.946 30 12.206 30 16s-.395 6.054-.706 7.273l-.001.003a3.01 3.01 0 0 1-1.796 2.04l-.015.006c-2.231.852-5.13 1.25-7.406 1.443a54 54 0 0 1-3.995.185h-.162q-.083 0-.236-.002a54.288 54.288 0 0 1-3.76-.183c-2.276-.192-5.174-.591-7.405-1.444l-.015-.005a3.01 3.01 0 0 1-1.796-2.04v-.003C2.394 22.053 2 19.794 2 16s.395-6.054.706-7.273l.001-.004a3.01 3.01 0 0 1 1.796-2.039l.015-.006c2.231-.852 5.13-1.251 7.406-1.443a54 54 0 0 1 3.995-.185zm.023 19.9h-.082q-.074 0-.219-.002a52.298 52.298 0 0 1-3.612-.176c-2.236-.189-4.896-.57-6.852-1.316a1.01 1.01 0 0 1-.597-.68C4.38 21.742 4 19.652 4 16s.38-5.743.643-6.775a1.01 1.01 0 0 1 .597-.682c1.956-.745 4.616-1.127 6.852-1.315a52 52 0 0 1 3.831-.178h.154l.219.001a52.216 52.216 0 0 1 3.612.176c2.236.19 4.896.57 6.852 1.316a1.01 1.01 0 0 1 .597.682C27.62 10.257 28 12.347 28 16s-.38 5.743-.643 6.775a1.01 1.01 0 0 1-.597.681c-1.956.746-4.616 1.127-6.852 1.316a52 52 0 0 1-3.831.178h-.072"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconYoutubeLogo = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconYoutubeLogo);
export default Memo;
